const Home = () => import("@/views/Home");
const Start = () => import("@/views/Start");
const routes = [
    {
        path: "/",
        redirect: {
            name: "start",
        },
    },
    {
        path: "/start",
        component: () => import('@/layouts'),
        children: [
            { path: '/', name: 'start', component: Start, },
            { path: '/home', name: 'home', component: Home, },
        ]
    }
];
export default routes;
